
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Routes } from "@/components/routing";
import { Suspense, lazy } from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Lazy load non-critical floating buttons and monitoring components
const WhatsAppButton = lazy(() => import("./components/WhatsAppButton").then(m => ({ default: m.WhatsAppButton })));
const GetQuoteButton = lazy(() => import("./components/GetQuoteButton").then(m => ({ default: m.GetQuoteButton })));
const ContactButton = lazy(() => import("./components/ContactButton").then(m => ({ default: m.ContactButton })));
const WebVitals = lazy(() => import("./components/WebVitals").then(m => ({ default: m.WebVitals })));
const PerformanceMonitor = lazy(() => import("./components/PerformanceMonitor").then(m => ({ default: m.PerformanceMonitor })));
const ServiceWorker = lazy(() => import("./components/ServiceWorker").then(m => ({ default: m.ServiceWorker })));


// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <BrowserRouter>
                <Routes />
                <Toaster />
                <Suspense fallback={null}>
                  <div className="fixed-buttons-container">
                    <WhatsAppButton />
                    <GetQuoteButton />
                    <ContactButton />
                  </div>
                  <WebVitals />
                  <PerformanceMonitor />
                  <ServiceWorker />
                  
                </Suspense>
            </BrowserRouter>
          </TooltipProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
